import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const deleteKeyShout = async (id: number) => {
	const response = await cmsClient.delete(`/homepage/admin/keyshout/${id}/`);

	return response.data;
};

const useDeleteKeyShout = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Key shout has been deleted" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["key-shouts"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(deleteKeyShout, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useDeleteKeyShout;
